import React from 'react'
import combineClass from '@helpers/combineClass'

const Card = ({ children, className = '' }) => {
  return <div className={combineClass('card', className)}>{children}</div>
}

export default Card
